import { KEY_ESCAPE } from 'keycode-js';
// import { disableScrolling, enableScrolling } from '../utils/scrolling';

export default {
    data: () => ({
        portalOpen: false,
        overlayOpen: false,
    }),
    render() {
        return this.$scopedSlots.default({
            portalOpen: this.portalOpen,
            overlayOpen: this.overlayOpen,
            onClose: this.onClose,
            setOverlayOpen: this.setOverlayOpen,
        });
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleEscape);
    },
    methods: {
        onClose() {
            this.portalOpen = false;
        },
        setOverlayOpen({ value }) {
            if (value) {
                this.portalOpen = value;
                window.addEventListener('keyup', this.handleEscape);
                // disableScrolling(250);
            } else {
                window.removeEventListener('keyup', this.handleEscape);
                // enableScrolling(250);
            }

            this.$nextTick(() => {
                this.overlayOpen = value;
            });
        },
        handleEscape(event) {
            if (event.keyCode === KEY_ESCAPE) {
                this.setOverlayOpen({ value: false });
            }
        },
    },
};
